import { TemplateType } from "@green0meter/api-client";

export const EXT_TO_TEMPLATE_TYPE: Record<string, TemplateType> = {
  ".docx": TemplateType.DOCX,
  ".xlsx": TemplateType.XLSX,
  ".pptx": TemplateType.PPTX,
  ".pdf": TemplateType.PDF,
};
